import { SelectOption } from '@/components/Form'
import { trainingCenterEnums } from './trainingCenterEnum'

const status: SelectOption[] = [
  {
    label: 'Active',
    value: trainingCenterEnums.Status.Active
  },
  {
    label: 'Closed',
    value: trainingCenterEnums.Status.Closed
  },
  {
    label: 'Provisional',
    value: trainingCenterEnums.Status.Provisional
  },
  {
    label: 'Withdrawn',
    value: trainingCenterEnums.Status.Withdrawn
  }
]

const trainingCenterType: SelectOption[] = [
  {
    label: 'Community Based',
    value: trainingCenterEnums.Type.CommunityBased
  },
  {
    label: 'Hospital Based',
    value: trainingCenterEnums.Type.HospitalBased
  }
]

const correspondingAddress: SelectOption[] = [
  {
    label: 'Center',
    value: trainingCenterEnums.Address.Centre
  },
  {
    label: 'Coordinator',
    value: trainingCenterEnums.Address.Coordinator
  }
]

export const trainingCenterOptions = { status, trainingCenterType, correspondingAddress }
